<template>
  <div class="map-container">
    <div class="map-list">
      <div class="map-item" v-for="item in companyList" :key="item.contactNumber" @mouseenter="handleMouseenter(item)"  @mouseleave="handleMouseleave">
        <div class="map-item-info">
          <div class="item-info-city">{{ extractCityFromAddress(item.detailAddress) }}</div>
          <div class="item-info-address">{{ handleChara(item.detailAddress, 60) }}</div>
        </div>
        <div class="item-info-phone">电话:{{ item.contactNumber }}</div>
      </div>
    </div>
    <div class="map-view">
      <MapIndex
        :latLng="{
            lat: currentAddress.latitude,
            lng: currentAddress.longitude,
            address: currentAddress.detailAddress}">
      </MapIndex>
    </div>
  </div>
</template>

<script setup>
import {getCompanyList} from "@/api/apiContact";
import {ref} from "vue";
import {extractCityFromAddress, handleChara} from "@/utils/title";
import MapIndex from '@/components/map/index.vue'

const companyList = ref([])
const currentAddress = ref({
  latitude:"",
  longitude:"",
  detailAddress:""
})
const queryCompanyList = async () => {
  const {code, data} = await getCompanyList()
  if (code === 200) {
    companyList.value = data;
  }
}
const handleMouseenter=(item)=>{
  currentAddress.value.detailAddress=item.detailAddress
  currentAddress.value.longitude=item.longitude
  currentAddress.value.latitude=item.latitude
}
const handleMouseleave=()=>{
  currentAddress.value.detailAddress=""
  currentAddress.value.longitude=""
  currentAddress.value.latitude=""
}
queryCompanyList()
</script>

<style lang="scss" scoped>
.map-container {
  width: 1200px;
  margin: 70px auto 0 auto;
  display: flex;
}
.map-list{
  width: 390px;
  height: 510px;
  overflow-y: auto;
  padding-right: 15px;
  /* 自定义滚动条 */
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #E3E3E3 transparent; /* Firefox */
}
/* Webkit浏览器滚动条样式 */
.map-list::-webkit-scrollbar {
  width: 5px; /* 滚动条宽度 */
}

.map-list::-webkit-scrollbar-track {
  background: transparent; /* 轨道背景 */
}

.map-list::-webkit-scrollbar-thumb {
  background: #E3E3E3; /* 滑块颜色 */
  border-radius: 5px; /* 圆角 */
  min-height: 136px; /* 最小高度（实际高度由内容决定） */
}
.map-item {
  width: 380px;
  height: 156px;
  background: #E5ECF6;
  box-shadow: 3px 3px 0 0 #BAC9DD;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  margin-bottom: 14px;
  justify-content: space-between;
  cursor: pointer;
  color: #242424;
  box-sizing: border-box;
  &:hover {
    color: #FFFFFF;
    background: #0048A9;
    box-shadow: 3px 3px 0 0 rgba(0, 72, 169, 0.2);
  }
}

.item-info-city {
  font-weight: bold;
  font-size: 20px;
}

.item-info-address {
  font-size: 14px;
  margin-top: 16px;
}

.item-info-phone {
  font-size: 14px;
}

.map-view {
  width: 780px;
  height: 499px;
  margin-left: 14px;
}
</style>
